import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'localTime'})
export class LocalTimePipe implements PipeTransform {
    transform(date?: Date): string {
        var localDate = '--';

        if (date) {
            const transformedDate = new Date(date);
            localDate = transformedDate.getFullYear() < 9999 ? formatDate(transformedDate, 'dd/MM/yyyy HH:mm', 'en-US') || localDate : localDate;
        }
          
        return localDate;
    }
}